import "./App.css";
import { useState } from "react";
import { Button, Scrollbar } from "retro-react";
import RainbowDivider from "./RainbowDivider";
import HeaderSection from "./HeaderSection";
import Summary from "./Summary";
import Plan from "./Plan";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";
import DresscodeSection from "./Dresscode";
import AccommodationSection from "./AccommodationSection";
import GettingThereSection from "./GettingThereSection";
import ThingsToDo from "./ThingsToDo";
import WhatToBring from "./WhatToBring";
import WhatsCovered from "./WhatsCovered";
import SpotifyAddSongsPrompt from "./SpotifyAddSongsPrompt";
import ScreenContainer from "./ScreenContainer";
import LocationBanner from "./LocationBanner";
import { DoubleBannerNav } from "./DoubleBannerNav";

function HomeScreen() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <HeaderSection />
      <RainbowDivider />
      <Summary />
      <LocationBanner />
      <RainbowDivider />
      <Plan />
      <DoubleBannerNav
        leftBanner={{
          title: t("dresscodeBenner.title"),
          description: t("dresscodeBenner.description"),
          url: "/dresscode",
          backgroundColor: "#ffccff",
          textColor: "#4a004a",
        }}
        rightBanner={{
          title: t("thingsToDoBanner.title"),
          description: t("thingsToDoBanner.description"),
          url: "/what-to-do",
          backgroundColor: "#ccffcc",
          textColor: "#004a00",
        }}
      />
    </>
  );
}

export default HomeScreen;
